export const EURO_DENOMINATIONS: number[] = [
  1, // 0.01 €
  2, // 0.02 €
  5, // 0.05 €
  10, // 0.10 €
  20, // 0.20 €
  50, // 0.50 €
  100, // 1 €
  200, // 2 €
  500, // 5 €
  1000, // 10 €
  2000, // 20 €
  5000, // 50 €
  10000, // 100 €
  20000, // 200 €
  50000, // 500 €
];

export const SEK_DENOMINATIONS: number[] = [
  100, // 1 kr
  200, // 2 kr
  500, // 5 kr
  1000, // 10 kr
  2000, // 20 kr
  5000, // 50 kr
  10000, // 100 kr
  20000, // 200 kr
  50000, // 500 kr
  100000, // 1000 kr
];

export const NOK_DENOMINATIONS: number[] = [
  100, // 1 kr
  500, // 5 kr
  1000, // 10 kr
  2000, // 20 kr
  5000, // 50 kr
  10000, // 100 kr
  20000, // 200 kr
  50000, // 500 kr
  100000, // 1000 kr
];

export const DKK_DENOMINATIONS: number[] = [
  50, // 0.50 kr
  100, // 1 kr
  200, // 2 kr
  500, // 5 kr
  1000, // 10 kr
  2000, // 20 kr
  5000, // 50 kr
  10000, // 100 kr
  20000, // 200 kr
  50000, // 500 kr
  100000, // 1000 kr
];

export const TRY_DENOMINATIONS: number[] = [
  1, // 0.01 TL
  5, // 0.05 TL
  10, // 0.10 TL
  25, // 0.25 TL
  50, // 0.50 TL
  100, // 1 TL
  500, // 5 TL
  1000, // 10 TL
  2000, // 20 TL
  5000, // 50 TL
  10000, // 100 TL
  20000, // 200 TL
];

export const GBP_DENOMINATIONS: number[] = [
  1, // 1p
  2, // 2p
  5, // 5p
  10, // 10p
  20, // 20p
  50, // 50p
  100, // £1
  200, // £2
  500, // £5
  1000, // £10
  2000, // £20
  5000, // £50
];
